import { combineReducers } from 'redux';

import invoices from './invoices';
import order from './order';
import orderDetail from './order-detail';
import orderNotes from './orderNotes';
import refundOrderSummary from './refund-order-summary';
import shippingNotifications from './shippingNotifications';
import debugTransactions from './debug-transaction';
import labelErrors from './label-errors';
import ui from './ui';

export default combineReducers({
  invoices,
  order,
  orderDetail,
  debugTransactions,
  labelErrors,
  orderNotes,
  refundOrderSummary,
  shippingNotifications,
  ui,
});
